import axios from 'axios';
import ListControls from './ListControls.vue';

export default {
  components: { ListControls },
  data: () => ({ listItems: [], listTotal: 0, listMeta: {}, listLoading: true, listError: '', listLoaded: false }),
  computed: {
    listPage() { const n = Number(this.$route.query.page); return Number.isSafeInteger(n) && n > 0 ? n : 1; },
    listPageSize() { const n = Number(this.$route.query.pageSize); return [25, 50, 100].includes(n) ? n : 25; }
  },
  created() {
    this.listSequence = 0;
    this.$watch(() => this.$route.fullPath, (next, previous) => {
      clearTimeout(this.listTimer);
      if (this.listCancel) this.listCancel.cancel();
      this.listSequence++;
      this.listLoading = true;
      this.listTimer = setTimeout(() => this.fetchList(), previous && next.includes('q=') ? 300 : 0);
    }, { immediate: true });
  },
  beforeDestroy() {
    this.listSequence++;
    clearTimeout(this.listTimer);
    if (this.listCancel) this.listCancel.cancel();
  },
  methods: {
    async fetchList() {
      const sequence = ++this.listSequence;
      if (this.listCancel) this.listCancel.cancel();
      this.listCancel = axios.CancelToken.source();
      this.listLoading = true; this.listError = ''; this.listItems = [];
      if (this.onListLoading) this.onListLoading();
      try {
        const { kind, ...filters } = this.listRequest();
        const { data } = await axios.get('/api/admin/lists/' + kind, {
          params: { ...filters, page: this.listPage, pageSize: this.listPageSize, q: (this.$route.query.q || '').slice(0, 200) },
          cancelToken: this.listCancel.token
        });
        if (sequence !== this.listSequence) return;
        const lastPage = Math.max(1, Math.ceil(data.total / this.listPageSize));
        if (this.listPage > lastPage) { this.changeListPage(lastPage, true); return; }
        this.listItems = data.items || []; this.listTotal = data.total; this.listMeta = data; this.listLoaded = true;
        if (this.onListLoaded) this.onListLoaded(data);
      } catch (error) {
        if (sequence === this.listSequence && !axios.isCancel(error)) this.listError = 'Could not load this list. Please try again.';
      } finally { if (sequence === this.listSequence) this.listLoading = false; }
    },
    changeListPage(page, replace = false) {
      const query = { ...this.$route.query, page: String(page) };
      this.$router[replace ? 'replace' : 'push']({ query }).catch(() => {});
    },
    changeListSize(size) {
      this.$router.push({ query: { ...this.$route.query, page: '1', pageSize: String(size) } }).catch(() => {});
    }
  }
};
